import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BACKEND_URL } from '@elio/shared/models';
import { Observable } from 'rxjs';
import { Locale } from 'scoped-translations';

@Injectable({ providedIn: 'root' })
export class LocalizationService {
  private SET_LOCALE_URL = `${BACKEND_URL}/test/info`;

  constructor(private http: HttpClient) {}

  setBackendLocale = (locale: Locale): Observable<void> => this.http.get<void>(`${this.SET_LOCALE_URL}?lang=${locale}`);
}
